import { Store } from 'vuex';

export let store: Store<any> = null as any;

export const registerStoreForHelpers = <T>(storeInstance: Store<T>) => {
	store = storeInstance;
};
